import React from "react";

export const UiWhiteCard = (props) => {
  const className = `df-white-card ${props.className || ""}`.trim();

  return (
    <>
      <div className={className} onClick={props.onClick}>
        {props.children}
      </div>
    </>
  );
};
